import {createStore} from 'redux';

export const store = createStore(basket,
	window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
store.subscribe(()=>{
	const basketIcon = document.querySelector('.basket');
	basketIcon.style.animation='basket 1.5s linear';
	return setTimeout(()=>{basketIcon.style.animation=''},1000)
});

function basket(state=JSON.parse(localStorage.getItem('basket'))||[], action){
	switch(action.type){
		case 'addItem':
			state=state.filter((i,n) =>{
				return i.name!=action.id.name;
			});
			localStorage.setItem('basket',JSON.stringify([...state, action.id]));
			return [...state, action.id];
			break;
		case 'changeQuantity':
			state=state.map((i,n) =>{
				if(i.name==action.id.name){
					return i.quantity+action.id.calc>0?
						Object.assign(i,{quantity:i.quantity+action.id.calc}):i;
				};
				return i;
			});
			localStorage.setItem('basket',JSON.stringify([...state]));
			return [...state];
			break;
		case 'deleteItem':
			state=state.filter((i,n) =>{
				return i.name!=action.id;
			});
			localStorage.setItem('basket',JSON.stringify([...state]));
			return [...state];
			break;
		case 'clearStore':
			return [];
			break;
		default:
			return state;
	}
};

export const addItem=(good)=>({type: 'addItem', id: good});
export const deleteItem=(good)=>({type: 'deleteItem', id: good});
export const changeQuantity=(name,n)=>({
	type: 'changeQuantity',
	id: {
		name: name,
		calc: n
	}
});
export const clearStore=()=>({type: 'clearStore'});